import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';

/* 시스템 관리 탭 — 시스템 관리(/system?tab=…) 와 IP 관리(/system/ip) 가 같이 쓴다.
 * 보안설정은 사이드바에 없어서 이 탭으로만 들어간다. 스타일은 management.css 의 mg-tabs */
export const SYSTEM_TABS = [
  { id: 'general', labelKey: 'pages.system.management.tabs.general', icon: 'settings' },
  { id: 'monitoring', labelKey: 'pages.system.management.tabs.monitoring', icon: 'monitor' },
  { id: 'alarm', labelKey: 'pages.system.management.tabs.alarm', icon: 'notifications' },
  { id: 'security', labelKey: 'pages.system.management.tabs.security', icon: 'security' },
  { id: 'data-collection', labelKey: 'pages.system.management.tabs.dataCollection', icon: 'sync' },
  { id: 'log', labelKey: 'pages.system.management.tabs.log', icon: 'description' },
  { id: 'ip', labelKey: 'pages.system.management.tabs.ip', icon: 'lan', path: '/system/ip' }
];

function SystemTabs({ active }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="mg-tabs" role="tablist">
      {SYSTEM_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          className={`mg-tab ${active === tab.id ? 'active' : ''}`}
          onClick={() => navigate(tab.path || `/system?tab=${tab.id}`)}
        >
          <span className="material-symbols-outlined">{tab.icon}</span>
          {t(tab.labelKey)}
        </button>
      ))}
    </div>
  );
}

export default SystemTabs;
